import { formatDistanceToNow } from "date-fns"

export default ({ timestamp }) => {
  if (!timestamp) return null

  const date = new Date(timestamp)
  if (isNaN(date)) return null

  return (
    <p className="m-0 fw-semibold small fs-7 text-primary">
      {formatDistanceToNow(date, { addSuffix: true })}
    </p>
  )
}